import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { Box, Flex } from 'reflexbox'
import Logo from './Logo'
import UserAvatar from './UserAvatar'
import { Container } from '../../healtheraComponents'

function AppBar() {
  return (
    <div>
      <Container p={2} align='center' justify='center'>
        <Box w={1 / 2}><Logo /></Box>
        <Flex w={1 / 2} justify='flex-end'>
          <Box>
            <StyledLink to='/activity-history'>Activity History Log</StyledLink>
          </Box>
          <UserAvatar />
        </Flex>
      </Container>
    </div>
  )
}

const StyledLink = styled(Link)`
  cursor: pointer;
  color: #000000;
  font-family: Assistant;
  font-size: 17px;
  font-weight: 600;
  text-decoration: none;
  line-height: 50px;
  margin-right: 15px
`

export default AppBar
